export const getRoutingBase = () => import.meta.env.ENV_ROUTING_BASE ?? 'reservations'
export const getEnvName = () => {
  switch (import.meta.env.ENV_NAME) {
    case 'DEV':
      return 'DEV'
    case 'STAGING':
      return 'STAGING'
    case 'PROD':
    default:
      return 'PROD'
  }
}
